import { Navigate } from 'react-router-dom'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useBreadcrumbs } from '../breadcrumbsContext/useBreadcrumbs/useBreadcrumbs'
import { RoutePath } from '../Routes'

import { Breadcrumbs, Flex, Menu, SectionItem, Typography } from '@percent/lemonade'
import { ReactComponent as DropdownSVG } from '@percent/partner-dashboard/common/assets/images/dropdown.svg'
import { useAuthDispatch, useAuthState } from '@percent/partner-dashboard/common/hooks'
import { SET_LOGOUT } from '@percent/partner-dashboard/context/auth'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import styles from './TopBar.module.scss'

export function TopBar() {
  const { t } = useTranslation()
  const dispatch = useAuthDispatch()
  const { authService } = useServices()
  const { breadcrumb } = useBreadcrumbs()
  const { user } = useAuthState()

  const handleLogout = useCallback(() => {
    authService.logout().then(() => {
      localStorage.removeItem('authState')
      dispatch({
        type: SET_LOGOUT
      })
    })

    return <Navigate to="/signin" />
  }, [authService, dispatch])

  const sections: SectionItem[] = [
    { key: 'settings', label: t('menu.settings'), as: 'link', to: RoutePath.SETTINGS, icon: 'settings' },
    { key: 'logout', label: t('menu.logout'), as: 'button', onClick: handleLogout, icon: 'log-out' }
  ]

  return (
    <Flex justify="end" bg="#fff">
      <Flex className={styles.toolBar}>
        <Flex w="100%">
          <Breadcrumbs items={breadcrumb} />
        </Flex>
        <Flex pos="relative">
          <Menu
            customTriggerComponent={
              <div className={styles.dropdown}>
                <Flex h="100%" align="center" gap={8} px={16} py={8} className={styles.targetButton}>
                  <Flex direction="column" gap={4}>
                    <Typography className={styles.nameText} variant="large">
                      {user?.fullName ?? user?.preferredName ?? user?.email}
                    </Typography>
                    <Typography className={styles.roleText} variant="default" data-testid="nav-user-role">
                      {user?.role?.displayName}
                    </Typography>
                  </Flex>
                  <DropdownSVG className={styles.icon} />
                </Flex>
              </div>
            }
            sections={[{ items: sections }]}
          />
        </Flex>
      </Flex>
    </Flex>
  )
}
